import { useEffect, useState } from "react";
import api from "../api/client.js";
import { useI18n } from "../i18n/I18nContext.jsx";
import Dropdown from "../components/Dropdown.jsx";
import "../styles/ActivityLog.css";

export default function ActivityLog() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [filterAction, setFilterAction] = useState("ALL");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    api
      .get("/activity/", { params: { page_size: 100 } })
      .then((r) => setItems(r.data.results || r.data));
  }, []);

  const getActionMeta = (action) => {
    const normalized = action.toUpperCase();
    if (normalized.includes("TRANSLATION")) {
      return {
        color: "violet",
        icon: "✨",
        label: "AI Translation"
      };
    }
    if (normalized.includes("EVIDENCE")) {
      return {
        color: "teal",
        icon: "📁",
        label: "Evidence Upload"
      };
    }
    if (normalized.includes("REPLY_SUBMITTED") || normalized.includes("SUBMIT")) {
      return {
        color: "green",
        icon: "✉",
        label: "Reply Submitted"
      };
    }
    if (normalized.includes("ASSIGN")) {
      return {
        color: "blue",
        icon: "👤",
        label: "Para Assigned"
      };
    }
    if (normalized.includes("REJECT") || normalized.includes("CLARIFICATION")) {
      return {
        color: "orange",
        icon: "⚠️",
        label: "Action Required"
      };
    }
    if (normalized.includes("CREATE") || normalized.includes("UPLOAD")) {
      return {
        color: "emerald",
        icon: "➕",
        label: "Created"
      };
    }
    if (normalized.includes("APPROVED") || normalized.includes("ACCEPT") || normalized.includes("RESOLVED")) {
      return {
        color: "green",
        icon: "✓",
        label: "Resolved"
      };
    }
    return {
      color: "gray",
      icon: "⚙",
      label: "System Event"
    };
  };

  // Get list of unique action types for filters
  const uniqueActions = ["ALL", ...new Set(items.map(item => item.action))];

  const filteredItems = items.filter((item) => {
    const matchesAction = filterAction === "ALL" || item.action === filterAction;
    const matchesSearch =
      item.detail?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.actor_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.action.replace(/_/g, " ").toLowerCase().includes(searchQuery.toLowerCase());
    return matchesAction && matchesSearch;
  });

  return (
    <div className="page-activity">
      <div className="page-header" style={{ marginBottom: "1.5rem" }}>
      </div>

      {/* Filter and Search Bar */}
      <div className="card toolbar" style={{ marginBottom: "1.5rem", display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center", padding: "1rem 1.5rem" }}>
        <div style={{ flexGrow: 1, minWidth: "200px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Search details or actor..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: "100%", padding: "0.5rem 0.75rem", borderRadius: "8px", border: "1px solid var(--border)" }}
          />
        </div>
        <div style={{ minWidth: 0 }}>
          <Dropdown
            value={filterAction}
            onChange={(v) => setFilterAction(v)}
            placeholder="All Actions"
            options={uniqueActions.map((act) => ({
              value: act,
              label: act === "ALL" ? "All Actions" : act.replace(/_/g, " "),
            }))}
          />
        </div>
      </div>

      {/* Timeline Stream */}
      <div className="timeline-container">
        {filteredItems.length === 0 ? (
          <div className="card" style={{ padding: "2rem", textAlign: "center" }}>
            <div className="muted" style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>📭</div>
            <div className="muted">{t("none")}</div>
          </div>
        ) : (
          filteredItems.map((a) => {
            const meta = getActionMeta(a.action);
            return (
              <div key={a.id} className="timeline-item">
                <div className={`timeline-marker ${meta.color}`} title={meta.label}>
                  {meta.icon}
                </div>
                <div className="timeline-card">
                  <div className="timeline-card-header">
                    <span className={`action-badge ${meta.color}`}>
                      {a.action.replace(/_/g, " ")}
                    </span>
                    <span className="timeline-timestamp">
                      {new Date(a.created_at).toLocaleString("en-IN")}
                    </span>
                  </div>
                  <div className="timeline-card-body">
                    <p className="timeline-detail-text">{a.detail || "—"}</p>
                  </div>
                  <div className="timeline-card-meta">
                    <div className="meta-field">
                      <span className="meta-icon">👤</span>
                      <span className="meta-label">Actor:</span>
                      <span className="meta-value">{a.actor_name}</span>
                    </div>
                    {a.ip_address && (
                      <div className="meta-field">
                        <span className="meta-icon">💻</span>
                        <span className="meta-label">IP Address:</span>
                        <span className="meta-value">{a.ip_address}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
